







































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Tasks,
  TasksTitle,
  StatusHeaderInfo,
  sendingStatus
} from "@/interfaces/status";
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import { Message } from "@/interfaces/alert";

@Component({
  metaInfo() {
    return {
      title: "Mos - Status"
    };
  },
  components: {},
  computed: {
    ...mapState("status", ["loadingInformation", "tasks", "sendStatus"])
  },
  methods: {
    ...mapMutations("status", ["setLoading", "setSend"]),
    ...mapMutations("alert", ["setMessage"]),
    ...mapActions("status", ["getProjects", "postVote", "postTask"])
  }
})
export default class Features extends Vue {
  search = "";
  moduleName = "";
  moduleDetails = "";
  DataSources = "";
  moduleDepartment = "";
  arrayDepartment = [
    { department: "All", id: 1 },
    { department: "Executive", id: 2 },
    { department: "Finance", id: 3 },
    { department: "Commercial", id: 4 },
    { department: "HSE", id: 5 },
    { department: "Community", id: 6 },
    { department: "Procurement", id: 7 },
    { department: "Operations", id: 8 },
    { department: "Mine Geology", id: 9 },
    { department: "Mining", id: 10 },
    { department: "Processing", id: 11 },
    { department: "Mobile Maintenance", id: 12 },
    { department: "Exploration", id: 13 }
  ];
  priority = 5;
  arrayPriority = [
    { priority: "Urgent", id: 1 },
    { priority: "High", id: 2 },
    { priority: "Normal", id: 3 },
    { priority: "Low", id: 4 },
    { priority: "No Priority", id: 5 }
  ];
  form = false;
  addRequest = false;
  newTitle = "";
  votes: string[] = [];
  loadingInformation?: boolean;
  titles: TasksTitle[] = [
    { title: "Reports", id: 0, tasks: [], on: false },
    { title: "Dashboards", id: 1, tasks: [], on: false },
    { title: "Tools", id: 2, tasks: [], on: false }
  ];
  headers: StatusHeaderInfo[] = [];
  getProjects!: () => void;
  setLoading!: (loading: boolean) => void;
  postVote!: (task: {}) => void;
  setMessage!: (data: Message) => void;
  setSend!: (send: boolean) => void;
  postTask!: (task: {}) => void;
  tasks!: [];
  sendStatus!: boolean;
  reports: Tasks[] = [];
  dashboard: Tasks[] = [];
  tools: Tasks[] = [];
  department: string[] = [];

  mounted() {
    this.votes = JSON.parse(localStorage.getItem("votes") || "[]") as string[];
    this.getProjects();
    this.headers = [
      { text: "Actions", value: "actions", width: 100, align: "center" },
      {
        text: "Module",
        value: "name",
        align: "start",
        width: 140
      },
      { text: "Details", value: "details", align: "center" },
      { text: "Department", value: "department", width: 120 },
      { text: "Source", value: "source", align: "center" },
      { text: "Start Date", value: "start", width: 140, align: "center" },
      { text: "Due Date", value: "dueDate", width: 140, align: "center" },
      { text: "Status", value: "status", align: "center" }
    ];
  }

  @Watch("sendStatus") onChange(val: sendingStatus) {
    if (val && val.type === "vote") {
      this.setMessage({
        text: "Vote sent",
        color: "success",
        icon: "mdi-check"
      });
    } else if (val && val.type === "task") {
      this.setMessage({
        text: "Task Create",
        color: "success",
        icon: "mdi-check"
      });
    }
    this.setSend(false);
  }
  @Watch("tasks") async onChanged(val: []) {
    let details;
    let department;
    let source;
    let start;
    let dueDate;
    let status;
    let id;
    let color;
    let votes;
    let on;

    this.setLoading(false);
    const values = JSON.parse(JSON.stringify(val));

    for await (const i of values) {
      details = "";
      department = "";
      source = "";
      start = "";
      dueDate = "";
      status = "";
      id = "";
      color = "";
      votes = "";
      on = false;

      if (i.tags.length >= 1) {
        id = i.id;
        for await (const j of this.votes) {
          if (j === id) {
            on = true;
            break;
          }
        }

        start = moment(parseInt(i.date_created)).format("MMM YYYY");
        if (i.due_date)
          dueDate = moment(parseInt(i.due_date)).format("MMM YYYY");
        else dueDate = "---";
        status = i.status.status;
        color = i.status.color;
        for await (const k of i.custom_fields) {
          if (k.name === "Votes") {
            if (k.value) {
              if (k.value !== "0") {
                votes = k.value;
              }
            }
          }
          if (department === "") {
            if (k.name === "Department")
              for (let i = 0; i < k.type_config.options.length; i++) {
                if (k.value === i) department = k.type_config.options[i].name;
                if (!k.value) department = "All";
              }
          }
          if (source === "") {
            if (k.name === "Data Sources") {
              if (k.value) source = k.value;
            }
          }
          if (details === "") {
            if (k.name === "Short description") {
              if (k.value) details = k.value;
            }
          }
        }

        for await (const j of i.tags) {
          if (j.name === "tool")
            this.tools.push({
              name: i.name,
              details: details,
              department: department,
              source: source,
              start: start,
              dueDate: dueDate,
              status: status,
              id: id,
              color: color,
              votes: votes,
              on: on
            });
          else if (j.name === "report")
            this.reports.push({
              name: i.name,
              details: details,
              department: department,
              source: source,
              start: start,
              dueDate: dueDate,
              status: status,
              id: id,
              color: color,
              votes: votes,
              on: on
            });
          else if (j.name === "dashboard")
            this.dashboard.push({
              name: i.name,
              details: details,
              department: department,
              source: source,
              start: start,
              dueDate: dueDate,
              status: status,
              id: id,
              color: color,
              votes: votes,
              on: on
            });
        }
      }
    }
    const aux: TasksTitle[] = this.titles;
    this.titles = [
      { title: "Reports", id: 0, tasks: this.reports, on: aux[0].on },
      { title: "Dashboards", id: 1, tasks: this.dashboard, on: aux[1].on },
      { title: "Tools", id: 2, tasks: this.tools, on: aux[2].on }
    ];
  }

  flipReport(index: boolean): string {
    return index ? "mdi-chevron-up" : "mdi-chevron-down";
  }

  open(index: TasksTitle): void {
    index.on = !index.on;
    this.titles[index.id] = index;
  }

  newRequest(item: TasksTitle): void {
    this.addRequest = true;
    this.newTitle = item.title.substring(0, item.title.length - 1);
  }
  vote(item: Tasks): void {
    let vote = 0;
    let flag = true;
    let pos = 0;
    const id: string = item.id;

    for (const i in this.votes) {
      if (this.votes[i] === id) {
        flag = false;
        pos = parseInt(i);
      }
    }

    if (flag) {
      this.votes.push(item.id);
      localStorage.setItem("votes", JSON.stringify(this.votes));
      const values = JSON.parse(JSON.stringify(this.titles));

      for (const i in values) {
        for (const j in values[i].tasks) {
          if (values[i].tasks[j].id === id) {
            values[i].tasks[j].on = true;
            vote =
              values[i].tasks[j].votes === ""
                ? 0
                : parseInt(values[i].tasks[j].votes);
            vote++;

            values[i].tasks[j].votes = vote.toString();
            this.titles = [];
            this.titles = values;

            this.updateVote(vote.toString(), id);
          }
        }
      }
    } else {
      this.votes.splice(pos, 1);
      localStorage.setItem("votes", JSON.stringify(this.votes));
      const values = JSON.parse(JSON.stringify(this.titles));

      for (const i in values) {
        for (const j in values[i].tasks) {
          if (values[i].tasks[j].id === id) {
            values[i].tasks[j].on = false;
            let vote: number =
              values[i].tasks[j].votes === ""
                ? 0
                : parseInt(values[i].tasks[j].votes);

            vote--;
            values[i].tasks[j].votes = vote > 0 ? vote.toString() : "";
            this.titles = [];
            this.titles = values;

            this.updateVote(vote.toString(), id);
          }
        }
      }
    }
  }
  async updateVote(vote: string, id: string): Promise<void> {
    const tasks = JSON.parse(JSON.stringify(this.tasks));
    for (const i of tasks) {
      if (i.id === id) {
        let idVote = null;

        for await (const area of i.custom_fields) {
          if (area.name === "Votes") {
            idVote = area.id;
          }
        }
        this.postVote({
          id: id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          custom_fields: [{ id: idVote, value: vote }]
        });

        this.setMessage({
          text: "Sending Vote",
          color: this.$vuetify.theme.dark ? "secondary" : "accent",
          icon: "mdi-vote"
        });
      }
    }
  }
  sendRequest(): void {
    if (!this.form) {
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.validate();
    } else {
      this.postTask({
        name: this.moduleName,
        priority: this.priority === 5 ? null : this.priority,
        tags: [this.newTitle.toLowerCase()],
        // eslint-disable-next-line @typescript-eslint/camelcase
        custom_fields: [
          {
            id: "c685ff19-2cb7-4c71-9021-0c6e97e1696c",
            value: this.DataSources
          },
          {
            id: "ddfc8980-435e-40e5-816a-cf07fa9724df",
            value: this.moduleDetails
          },
          {
            id: "7534f222-83b2-407d-8383-365af1000332",
            value: parseInt(this.moduleDepartment) - 1
          }
        ]
      });
      this.setMessage({
        text: "Creating Task in progress",
        color: "accent"
      });
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.reset();
      // eslint-disable-next-line
      //@ts-ignore
      this.$refs.form.resetValidation();
    }
  }
}
